import { Component, HostBinding, Input } from '@angular/core';
import { AlertComponent } from './alert.component';
import { coerceCssPixelValue, NumberInput } from '@angular/cdk/coercion';

@Component({
    selector: 'lui-alert-icon',
    template: `<mat-icon [svgIcon]="icon"></mat-icon>`,
    styleUrls: ['./alert-icon.component.scss'],
    standalone: false
})
export class AlertIconComponent {
  @HostBinding('class.lui-alert-icon-info') get infoLevelCass() {
    return this.alertComponent.level === 'info';
  }
  @HostBinding('class.lui-alert-icon-elevated') get elevatedLevelCass() {
    return this.alertComponent.level === 'elevated';
  }
  @HostBinding('class.lui-alert-icon-success') get successLevelCass() {
    return this.alertComponent.level === 'success';
  }
  @HostBinding('class.lui-alert-icon-danger') get dangerLevelCass() {
    return this.alertComponent.level === 'danger';
  }
  @HostBinding('class.lui-alert-icon-info-solid') get infoSolidLevelCass() {
    return this.alertComponent.level === 'info-solid';
  }
  @HostBinding('class.lui-alert-icon-elevated-solid')
  get elevatedSolidLevelCass() {
    return this.alertComponent.level === 'elevated-solid';
  }
  @HostBinding('class.lui-alert-icon-success-solid')
  get successSolidLevelCass() {
    return this.alertComponent.level === 'success-solid';
  }
  @HostBinding('class.lui-alert-icon-danger-solid') get dangerSolidLevelCass() {
    return this.alertComponent.level === 'danger-solid';
  }

  @Input() icon!: string;

  @Input() get size(): string | null {
    return this._size;
  }
  set size(value: NumberInput) {
    this._size = coerceCssPixelValue(value);
  }
  private _size: string | null = '24px';

  @HostBinding('style.--size') get sizeCssVariable() {
    return this.size;
  }

  constructor(private alertComponent: AlertComponent) {}
}
